import { FC } from "react";

import {
  DirectionEnum,
  formatHubSettingsDirectionLabel,
  IHubSettingsGridItem,
} from "@ryde/shared";

import {
  HubStationsIdLink,
  HubStationsTooltipList,
  HubStationsTooltipRow,
} from "./hub-stations-cell.styled";

interface IHubStationsTooltipContentProps {
  items: IHubSettingsGridItem[];
  onStationOpen: (stationId: number) => void;
}

export const HubStationsTooltipContent: FC<IHubStationsTooltipContentProps> = ({
  items,
  onStationOpen,
}) => {
  return (
    <HubStationsTooltipList>
      {items.map(item => (
        <HubStationsTooltipRow
          key={`${item.hubStationId}-${item.stationId}-${item.direction ?? DirectionEnum.Both}`}
        >
          <HubStationsIdLink onClick={() => onStationOpen(item.hubStationId)}>
            {item.hubStationId}
          </HubStationsIdLink>
          <span>{item.hubStationName}</span>
          <span>-</span>
          <HubStationsIdLink onClick={() => onStationOpen(item.stationId)}>
            {item.stationId}
          </HubStationsIdLink>
          <span>{item.stationName}</span>
          {item.direction ? (
            <span>({formatHubSettingsDirectionLabel(item.direction)})</span>
          ) : null}
        </HubStationsTooltipRow>
      ))}
    </HubStationsTooltipList>
  );
};
